<template>
  <v-dialog v-model="active" width="500">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="on" />
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Download Area: {{ field["nm_field"] || "" }}
      </v-card-title>
      <v-card-text class="px-0">
        <v-list rounded>
          <v-list-item v-for="type in contentTypes" :key="type['value']"
            @click="() => { onDownloadClick(type['value']) }">
            <v-list-item-icon>
              <v-icon>mdi-file</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ type["text"] }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="accent" text @click="active = false" :disabled="isDownloading">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Field } from "../../../../helpers/fields/models"
import { FIELD_CONTENT_TYPES, FIELD_CONTENT_TYPES_DETAILS } from "../../../../helpers/geometries/constants"
import { isEqual } from "lodash/lang"
import { downloadField } from "../../../../api/api-project"
import download from "downloadjs"

export default {
  name: "FieldDownloadDialog",
  props: {
    field: {
      type: Field,
      required: true,
    }
  },
  data: () => ({
    active: false,
    isDownloading: false,
  }),
  methods: {
    onDownloadClick(contentType) {
      let extraHeaders = null
      if (isEqual(contentType, FIELD_CONTENT_TYPES.X_ESRI_SHAPE))
        extraHeaders = {
          responseType: "arraybuffer"
        }
      this.isDownloading = true
      downloadField(this.$apiAuth.getAuthToken(), this.field["id_field"], contentType, extraHeaders)
        .then((res) => {
          const fileExt = this.getFileDownloadEXT(contentType)
          let finalData = res.data
          const fileName = `${this.field["nm_field"] || this.field["id_field"]}.${fileExt}`
          if (isEqual(contentType, FIELD_CONTENT_TYPES.GEOJSON))
            finalData = JSON.stringify(res.data)
          const blob = new Blob([finalData], { type: contentType })
          download(blob, fileName, contentType)

          this.isDownloading = false
        })
    },
    getFileDownloadEXT(contentType) {
      switch (contentType) {
        case FIELD_CONTENT_TYPES.GEOJSON:
          return "geojson"
        case FIELD_CONTENT_TYPES.X_ESRI_SHAPE:
          return "zip"
        case FIELD_CONTENT_TYPES.KML:
          return "kml"
        default:
          return ""
      }
    }
  },
  computed: {
    contentTypes() {
      return FIELD_CONTENT_TYPES_DETAILS
    },
  }
}
</script>

<style scoped></style>
